import { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useTranslationHook from "../../hooks/useTranslationHook";
import { getDiscountPrice } from "../../helpers/product";
import { deleteFromCart } from "../../store/slices/cart-slice";
import { numberWithCommas } from "../../shared/helpersMethod";
import { Modal } from "react-bootstrap";
import ModalCloseButton from "../modal/components/ModalCloseButton";
import ButtonCommon from "../button-common/ButtonCommon";
import Wrapper from "./Wrapper";
import { useScrollLock } from "../../hooks/useScrollLock";
const CartAlert = ({ onPressClose, visible }) => {
  const dispatch = useDispatch();
  const { t } = useTranslationHook();
  const { unlockScroll } = useScrollLock();
  const currency = useSelector((state) => state.currency);
  const { cartItems } = useSelector((state) => state.cart);
  let cartTotalPrice = 0;
  var cartSingleItem = [cartItems[cartItems.length - 1]];
  useEffect(() => {
    if (visible) {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      unlockScroll();
    }
  }, [visible]);
  return (
    // <Wrapper visible={visible} onClose={onPressClose}>
    <div onClick={onPressClose}>
      <Modal
        show={visible}
        onBackdropClick={onPressClose}
        onHide={onPressClose}
        backdrop={true}
        keyboard={true}
        autoFocus={false}
        scrollable={false}
        animation={false}
        contentClassName="wrapper-alert-cart "
        dialogClassName="cart-alert-dialog"
      >
        <ModalCloseButton onPressCross={onPressClose} />
        <Modal.Body className=" error-modal-wrapper ">
          <div
            className={`cart-alert shopping-cart-content ${visible && "active"}`}
          >
            {cartItems && cartItems.length > 0 ? (
              <Fragment>
                <ul>
                  {cartSingleItem.map((item) => {
                    const discountedPrice = getDiscountPrice(
                      item.price,
                      item.discount
                    );
                    const finalProductPrice = (
                      item.price * currency.currencyRate
                    ).toFixed(2);
                    const finalDiscountedPrice = (
                      discountedPrice * currency.currencyRate
                    ).toFixed(2);

                    discountedPrice != null
                      ? (cartTotalPrice += finalDiscountedPrice * item.quantity)
                      : (cartTotalPrice += finalProductPrice * item.quantity);

                    return (
                      <li
                        className="single-shopping-cart"
                        key={item.cartItemId}
                      >
                        <div className="shopping-cart-img">
                          <Link to={`/product/${item.slug}/${item.id}`}>
                            <img
                              alt=""
                              src={process.env.PUBLIC_URL + item.image[0]}
                              className="img-fluid"
                            />
                          </Link>
                        </div>
                        <div className="shopping-cart-title">
                          <h4>
                            <Link to={`/product/${item.slug}/${item.id}`}>
                              {" "}
                              {item.name}{" "}
                            </Link>
                          </h4>
                          <h6>
                            {t("txt_quantity")}: {item.quantity}
                          </h6>
                          <span>
                            {discountedPrice !== null
                              ? numberWithCommas(finalDiscountedPrice)
                              : numberWithCommas(finalProductPrice)}
                            <span style={{ marginLeft: 5, marginRight: 5 }}>
                              {currency.currencySymbol}
                            </span>
                          </span>

                          {item.selectedProductColor &&
                          item.selectedProductSize ? (
                            <div className="cart-item-variation">
                              <span>Color: {item.selectedProductColor}</span>
                              <span>Size: {item.selectedProductSize}</span>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </li>
                    );
                  })}
                </ul>

                <div className="shopping-cart-btn btn-hover- text-center">
                  <Link
                    className="default-btn"
                    to={process.env.PUBLIC_URL + "/checkout"}
                  >
                    {t("txt_checkout")}
                  </Link>
                  <Link
                    style={{
                      background: "var(--button-color)",
                      color: "white",
                    }}
                    className="default-btn"
                    to={process.env.PUBLIC_URL + "/cart"}
                  >
                    {t("txtx_view_cart")}
                  </Link>

                  <Link
                    style={{
                      border: 0,
                      textDecorationLine: "underline",
                      textUnderlineOffset: "0.5rem",
                      paddingBottom: 10,
                      marginBottom: 0,
                    }}
                    className="default-btn"
                    onClick={onPressClose}
                    // to={process.env.PUBLIC_URL + "/checkout"}
                  >
                    {t("continue_shopping")}
                  </Link>
                </div>
              </Fragment>
            ) : (
              <p className="text-center">{t("txt_no_items")}</p>
            )}
          </div>
        </Modal.Body>
        {/* </Wrapper> */}
      </Modal>
    </div>
  );
};

export default CartAlert;
